module.exports = __webpack_public_path__ + "img/mihai.ac6556fa.png";